module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editsuperSpecialNews"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("市场专题")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑新闻")])], 1), _vm._v(" "), _c('div', {
    staticClass: "edit-superSpecial-news-box"
  }, [_c('div', {
    staticClass: "superSpecial-list-box"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入关键字进行过滤"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "specialList",
    attrs: {
      "filter-node-method": _vm.filterNode,
      "data": _vm.specialList,
      "props": _vm.propsRules,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.selectSpecial
    }
  })], 1), _vm._v(" "), (_vm.specialId) ? _c('div', {
    staticClass: "add-news-container"
  }, [_c('el-card', {
    staticClass: "select-module"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("项目和模板")])]), _vm._v(" "), _c('div', {
    staticClass: "superSpecial-select"
  }, [_c('span', [_vm._v("选择模块")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.addNewsSelectModule
    },
    model: {
      value: (_vm.moduleId),
      callback: function($$v) {
        _vm.moduleId = $$v
      },
      expression: "moduleId"
    }
  }, [_c('el-option', {
    key: -1,
    attrs: {
      "label": "默认模块",
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.moduleList), function(item) {
    return _c('el-option', {
      key: item.moduleId,
      attrs: {
        "label": item.moduleName,
        "value": item.moduleId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "superSpecial-select"
  }, [_c('span', [_vm._v("选择组件")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.addNewsSelectTemplate
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  }, _vm._l((_vm.newsTypeList), function(item) {
    return _c('el-option', {
      key: item.newsTypeId,
      attrs: {
        "label": item.newsTypeName,
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newsTypeId),
      expression: "newsTypeId"
    }],
    staticClass: "add-news"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("新闻内容")])]), _vm._v(" "), (_vm.newsTypeName === '大图新闻') ? _c('yd-big-img-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '视频新闻') ? _c('yd-video-news-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '多图新闻') ? _c('yd-three-img-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true,
      "threeImages": _vm.duotuImages
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '单图新闻') ? _c('yd-one-img-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '无图新闻') ? _c('yd-none-img-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '轮播图') ? _c('yd-slides-news-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "lunboImages": _vm.lunboImages,
      "lunboSlideNum": _vm.lunboSlideNum,
      "lunboURLs": _vm.lunboURLs,
      "lunboInfos": _vm.lunboInfos,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset,
      "addSlide": _vm.addSlide,
      "delSlide": _vm.delSlide
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '轮播图（竖）') ? _c('yd-slides-news-vertical-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "lunboImages": _vm.lunboImages,
      "lunboSlideNum": _vm.lunboSlideNum,
      "lunboURLs": _vm.lunboURLs,
      "lunboInfos": _vm.lunboInfos,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset,
      "addSlide": _vm.addSlide,
      "delSlide": _vm.delSlide
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '视频直播') ? _c('yd-live-news-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '线索收集') ? _c('yd-collect-news-form', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "projectList": _vm.projectList,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '按钮') ? _c('YdButtonForm', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "addForm": true
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.newsTypeId) ? _c('el-card', {
    staticClass: "news-preview"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("新闻预览")])]), _vm._v(" "), (_vm.newsTypeName === '大图新闻') ? _c('yd-big-img', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '单图新闻') ? _c('yd-one-img', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '轮播图') ? _c('yd-slides-news', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "lunboSlideNum": _vm.lunboSlideNum,
      "lunboImages": _vm.lunboImages
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '轮播图（竖）') ? _c('yd-slides-news-vertical', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "lunboSlideNum": _vm.lunboSlideNum,
      "lunboImages": _vm.lunboImages
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '多图新闻') ? _c('yd-three-img', {
    attrs: {
      "newsData": _vm.addNewsForm,
      "threeImages": _vm.duotuImages
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '视频直播') ? _c('yd-live-news', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '视频新闻') ? _c('yd-video-news', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '无图新闻') ? _c('yd-none-img', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '线索收集') ? _c('yd-collect-news', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newsTypeName === '按钮') ? _c('YdButton', {
    attrs: {
      "newsData": _vm.addNewsForm
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.newsList) ? _c('div', {
    staticClass: "news-list-box"
  }, [_c('div', {
    staticClass: "header-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.newsList.focusImgUrl,
      "alt": "图片地址错误"
    }
  })]), _vm._v(" "), (_vm.newsList.specialContent) ? _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "desc-icon"
  }, [_vm._v("概述")]), _vm._v(" "), _c('span', {
    staticClass: "desc-content"
  }, [_vm._v(_vm._s(_vm.newsList.specialContent))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.newsList.modules), function(_module) {
    return _c('div', {
      staticClass: "component-module"
    }, [(_module.moduleIdNew != -1) ? _c('div', {
      staticClass: "module-header"
    }, [(_module.bgImage) ? _c('img', {
      attrs: {
        "src": _module.bgImage,
        "alt": "图片地址错误"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      class: [_module.bgImage ? '' : 'title2', 'title']
    }, [_vm._v(_vm._s(_module.moduleName))])]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "news-list"
    }, _vm._l((_module.moduleNewsList), function(news) {
      return _c('li', [(news.newsTypeName === '多图新闻') ? _c('yd-three-img', {
        attrs: {
          "newsData": news,
          "threeImages": news.newsContentImage.split(';')
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '线索收集') ? _c('yd-collect-news', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '单图新闻') ? _c('yd-one-img', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '大图新闻') ? _c('yd-big-img', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '轮播图') ? _c('yd-slides-news', {
        attrs: {
          "newsData": news,
          "lunboSlideNum": news.newsContentImage.split(';').length,
          "lunboImages": news.newsContentImage.split(';')
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '轮播图（竖）') ? _c('yd-slides-news-vertical', {
        attrs: {
          "newsData": news,
          "lunboSlideNum": news.newsContentImage.split(';').length,
          "lunboImages": news.newsContentImage.split(';')
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '视频直播') ? _c('yd-live-news', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '视频新闻') ? _c('yd-video-news', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '无图新闻') ? _c('yd-none-img', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName === '按钮') ? _c('YdButton', {
        attrs: {
          "newsData": news
        },
        on: {
          "newsClick": _vm.newsItemClick
        }
      }) : _vm._e(), _vm._v(" "), (news.newsTypeName) ? _c('el-button-group', {
        staticClass: "btn-group"
      }, [_c('el-button', {
        attrs: {
          "size": "mini",
          "type": "danger"
        },
        on: {
          "click": function($event) {
            _vm.delNews(news.newsContentId)
          }
        }
      }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
        attrs: {
          "size": "mini",
          "type": "warning"
        },
        on: {
          "click": function($event) {
            _vm.editNews(news)
          }
        }
      }, [_vm._v("编辑")])], 1) : _vm._e()], 1)
    }))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑-新闻",
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-card', {
    staticClass: "edit-news-preview-box",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "margin": "0 auto"
    }
  }, [(_vm.editNewsForm.newsTypeName === '多图新闻') ? _c('yd-three-img', {
    attrs: {
      "newsData": _vm.editNewsForm,
      "threeImages": _vm.editNewsForm.newsContentImage.split(';')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '线索收集') ? _c('yd-collect-news', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '单图新闻') ? _c('yd-one-img', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '大图新闻') ? _c('yd-big-img', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '轮播图') ? _c('yd-slides-news', {
    attrs: {
      "newsData": _vm.editNewsForm,
      "lunboSlideNum": _vm.lunboSlideNum2,
      "lunboImages": _vm.lunboImages2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '轮播图（竖）') ? _c('yd-slides-news-vertical', {
    attrs: {
      "newsData": _vm.editNewsForm,
      "lunboSlideNum": _vm.lunboSlideNum2,
      "lunboImages": _vm.lunboImages2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '视频直播') ? _c('yd-live-news', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '视频新闻') ? _c('yd-video-news', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '无图新闻') ? _c('yd-none-img', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '按钮') ? _c('YdButton', {
    attrs: {
      "newsData": _vm.editNewsForm
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-card', [(_vm.editNewsForm.newsTypeName === '大图新闻') ? _c('yd-big-img-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '视频新闻') ? _c('yd-video-news-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '多图新闻') ? _c('yd-three-img-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false,
      "threeImages": _vm.duotuImages2
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '单图新闻') ? _c('yd-one-img-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '无图新闻') ? _c('yd-none-img-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '轮播图') ? _c('yd-slides-news-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "lunboImages": _vm.lunboImages2,
      "lunboSlideNum": _vm.lunboSlideNum2,
      "lunboURLs": _vm.lunboURLs2,
      "lunboInfos": _vm.lunboInfos2,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset,
      "addSlide": _vm.addSlide2,
      "delSlide": _vm.delSlide2,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '轮播图（竖）') ? _c('yd-slides-news-vertical-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "lunboImages": _vm.lunboImages2,
      "lunboSlideNum": _vm.lunboSlideNum2,
      "lunboURLs": _vm.lunboURLs2,
      "lunboInfos": _vm.lunboInfos2,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormReset": _vm.newsFormReset,
      "addSlide": _vm.addSlide2,
      "delSlide": _vm.delSlide2,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '视频直播') ? _c('yd-live-news-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '线索收集') ? _c('yd-collect-news-form', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm,
      "projectList": _vm.projectList,
      "addForm": false
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editNewsForm.newsTypeName === '按钮') ? _c('YdButtonForm', {
    attrs: {
      "isEdit": true,
      "newsData": _vm.editNewsForm
    },
    on: {
      "newsFormSubmit": _vm.newsFormSubmit,
      "newsFormCancle": _vm.newsFormCancle
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-37d2687c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/Edit.vue
// module id = 754
// module chunks = 1